import { concat, from, NEVER, } from "rxjs";
import { exhaustMap, ignoreElements, mergeAll, publishReplay, takeUntil, toArray, } from "rxjs/operators";
import { endWith } from "./endWith";
export function exhaustTap(next) {
    return (source) => source.pipe(publishReplay(1, undefined, (published) => published.pipe(exhaustMap((value) => concat(published, NEVER).pipe(takeUntil(from(next(value)).pipe(ignoreElements(), endWith(null))), toArray(), mergeAll())))));
}
//# sourceMappingURL=exhaustTap.js.map